import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './app/App.scss';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom'


ReactDOM.render(
    <React.StrictMode>
      <Router>
        <App />
      </Router>
      <script src="https://kit.fontawesome.com/9184fe8771.js" crossOrigin="anonymous"></script>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();